import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Glyph } from './GameIcon';

const TIPS = ['ghost', 'armor', 'electric', 'fire', 'freeze', 'golden', 'closeCall', 'streak', 'chain', 'missions', 'rooms', 'replay', 'boost'] as const;
const ROTATE_MS = 6000;

/** A random gameplay tip for waiting moments (matchmaking, countdown); `rotate` cycles through more. */
export function Tip({ rotate = false }: { rotate?: boolean }) {
  const { t } = useTranslation();
  const [i, setI] = useState(() => Math.floor(Math.random() * TIPS.length));
  useEffect(() => {
    if (!rotate) return;
    const id = setInterval(() => setI((n) => (n + 1) % TIPS.length), ROTATE_MS);
    return () => clearInterval(id);
  }, [rotate]);
  return (
    <p key={i} className="tip">
      <Glyph e="💡" /> {t(`tips.${TIPS[i]}`)}
    </p>
  );
}
